import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import enUs from '../../locale/en_US';
import { prefix } from "../../../../wui-core/src/index.js";

function noop() {}

export var propType = {
  className: PropTypes.string,
  locale: PropTypes.object,
  style: PropTypes.object,
  visible: PropTypes.bool,
  onSelect: PropTypes.func,
  prefixCls: PropTypes.string,
  onChange: PropTypes.func,
  onOk: PropTypes.func
};
export var defaultProp = {
  locale: enUs,
  style: {},
  visible: true,
  prefixCls: "".concat(prefix, "-date-calendar"),
  className: '',
  onSelect: noop,
  onChange: noop,
  onClear: noop,
  renderFooter: function renderFooter() {
    return null;
  },
  renderSidebar: function renderSidebar() {
    return null;
  }
};
export var commonMixinWrapper = function commonMixinWrapper(ComposeComponent) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_ComposeComponent) {
    _inherits(_class, _ComposeComponent);

    var _super = _createSuper(_class);

    function _class() {
      var _this;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "getFormat", function () {
        var format = _this.props.format;
        var _this$props = _this.props,
            locale = _this$props.locale,
            timePicker = _this$props.timePicker;

        if (!format) {
          if (timePicker) {
            format = locale.dateTimeFormat;
          } else {
            format = locale.dateFormat;
          }
        }

        return format;
      });

      _defineProperty(_assertThisInitialized(_this), "focus", function () {
        if (_this.focusElement) {
          _this.focusElement.focus();
        } else if (_this.rootInstance) {
          _this.rootInstance.focus();
        }
      });

      _defineProperty(_assertThisInitialized(_this), "saveFocusElement", function (focusElement) {
        _this.focusElement = focusElement;
      });

      _defineProperty(_assertThisInitialized(_this), "saveRoot", function (root) {
        _this.rootInstance = root;
      });

      return _this;
    }

    _createClass(_class, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps) {
        return this.props.visible || nextProps.visible;
      }
    }]);

    return _class;
  }(ComposeComponent), _defineProperty(_class, "displayName", 'CommonMixinWrapper'), _defineProperty(_class, "defaultProps", ComposeComponent.defaultProps), _defineProperty(_class, "getDerivedStateFromProps", ComposeComponent.getDerivedStateFromProps), _temp;
};


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/mixin/CommonMixin.js